import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import image from "../assets/generated/aped-leadership-v2.png"

const AboutSection = () => {
  const { t } = useTranslation();
  
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  

  return (
    <section className="aped-about-section">
      <div className="aped-about-content-wrapper">
        <h2 className="aped-about-title">{t('about.title')}</h2>
        <div className="aped-about-content">
          <div className="aped-about-image-container">
            <img src={image} alt="APED leaders discussing an investment strategy in Douala" className="aped-about-image" loading="lazy" />
          </div>
          <div className="aped-about-text">
            <p className="aped-about-description">
              <strong className='strongg'>APED INVESTMENT</strong> {t('about.description1')}
            </p>
            <p className="aped-about-description">{t('about.description2')}</p>
            <p className="aped-about-description">{t('about.description3')}</p>
          </div>
        </div>
        <div className="aped-about-cta-container">
          <button className="aped-about-cta-button" onClick={scrollToContact}>
            {t('about.cta')}
            <ArrowRight className="aped-about-icon" />
          </button>
        </div>
      </div>
      <div className="aped-about-background-elements">
        <div className="aped-about-circle aped-about-circle-1"></div>
        <div className="aped-about-circle aped-about-circle-2"></div>
        <div className="aped-about-square"></div>
      </div>
      <style jsx>{`
        .strongg {
          color: #b4a35e;
        }
        .aped-about-section {
          position: relative;
          padding: 6rem 2rem;
          background-color: #f8f9fa;
          overflow: hidden;
          font-family: 'Inter', sans-serif;
        }

        .aped-about-content-wrapper {
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        .aped-about-title {
          font-size: 2.5rem;
          color: #1b1f3a;
          margin-bottom: 2rem;
          text-align: center;
          position: relative;
        }

        .aped-about-title::after {
          content: '';
          display: block;
          width: 50px;
          height: 3px;
          background-color: #b4a35e;
          margin: 1rem auto 0;
        }

        .aped-about-content {
          display: flex;
          gap: 2rem;
          margin-bottom: 3rem;
        }

        .aped-about-image-container {
          flex-shrink: 0;
          width: 400px;
          margin-right: 2rem;
        }

        .aped-about-image {
          width: 100%;
          height: auto;
          border-radius: 8px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .aped-about-text {
          flex: 1;
        }

        .aped-about-description {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #34495e;
          margin-bottom: 1rem;
          text-align: justify; /* Add this line to justify the text */
        }

        .aped-about-cta-container {
          text-align: center;
        }

        .aped-about-cta-button {
          background-color: #b4a35e;
          color: white;
          font-size: 1.1rem;
          font-weight: 600;
          padding: 12px 24px;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          transition: all 0.3s ease;
        }

        .aped-about-cta-button:hover {
          background-color: #c9b87d;
          transform: translateY(-2px);
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .aped-about-icon {
          margin-left: 8px;
          transition: transform 0.3s ease;
        }

        .aped-about-cta-button:hover .aped-about-icon {
          transform: translateX(4px);
        }

        .aped-about-background-elements {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }

        .aped-about-circle {
          position: absolute;
          border-radius: 50%;
        }

        .aped-about-circle-1 {
          width: 300px;
          height: 300px;
          background-color: rgba(52, 152, 219, 0.1);
          top: -100px;
          left: -100px;
        }

        .aped-about-circle-2 {
          width: 200px;
          height: 200px;
          background-color: rgba(46, 204, 113, 0.1);
          bottom: -50px;
          right: -50px;
        }

        .aped-about-square {
          position: absolute;
          width: 100px;
          height: 100px;
          background-color: rgba(155, 89, 182, 0.1);
          transform: rotate(45deg);
          top: 50%;
          left: 50%;
        }

        @media (max-width: 1200px) {
          .aped-about-image-container {
            width: 350px;
          }
        }

        @media (max-width: 992px) {
          .aped-about-image-container {
            width: 300px;
          }
        }

        @media (max-width: 768px) {
          .aped-about-section {
            padding: 4rem 1rem;
          }

          .aped-about-title {
            font-size: 2rem;
          }

          .aped-about-content {
            flex-direction: column;
            align-items: center;
            gap: 1rem;
          }

          .aped-about-image-container {
            width: 100%;
            max-width: 400px;
            margin-right: 0;
            margin-bottom: 1rem;
          }

          .aped-about-description {
            font-size: 1rem;
          }

          .aped-about-cta-button {
            font-size: 1rem;
            padding: 10px 20px;
          }

          .aped-about-circle-1 {
            width: 150px;
            height: 150px;
            top: -50px;
            left: -50px;
          }

          .aped-about-circle-2 {
            width: 100px;
            height: 100px;
            bottom: -25px;
            right: -25px;
          }

          .aped-about-square {
            width: 50px;
            height: 50px;
          }
        }

        @media (max-width: 480px) {
          .aped-about-title {
            font-size: 1.75rem;
          }

          .aped-about-description {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </section>
  );
};

export default AboutSection;
